// extracted by mini-css-extract-plugin
export default {"container":"SignupFromInvitation_container__hrAwO"};